<template>
  <div class="content" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
    <v-snackbar v-model="alertSuccess" :timeout="4000" top right color='primary' >
        <v-icon x-medium class="white--text">mdi-checkbox-marked-circle</v-icon>    <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-snackbar v-model="alertFailed" :timeout="4000" top right color='red' >
      <v-icon x-medium class="white--text">mdi-minus-circle</v-icon>   <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-breadcrumbs :items="page" class="ml-2 mt-0 pt-0"></v-breadcrumbs>
    <template >
      <v-toolbar flat class="rounded-lg">
        <v-toolbar-title style="margin-left: 20px;"><v-icon class="mr-2">mdi-format-list-bulleted</v-icon>{{ this.$store.state.title }}</v-toolbar-title>
        <v-spacer></v-spacer>
          <!--v-dialog-->
        <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn 
                v-show=insertact
                outlined
                rounded
                small
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
                >
                Add Menu Management
                <v-icon class="ml-2">mdi-plus</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title><span class="text-h6">{{ formTitle }}</span></v-card-title>
              <v-card-text class="overflow-card" style="max-height: 600px; overflow-y: auto;">
                <v-form class="ml-2" ref="form" lazy-validation>
                  <v-container>
                    <v-row class="my-3">
                      <v-col cols="12" sm="12" md="12" class="my-0 py-0">
                        <v-select 
                          dense outlined 
                          :items="modules_val"
                          
                          item-text="namemodule" 
                          item-value="valuemodule" 
                          v-model="modules" 
                          label="Module">
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" class="my-0 py-0">
                        <v-text-field 
                          prepend-inner-icon="mdi-folder" 
                          outlined dense 
                          v-model="namefolder" 
                          label="Nama Folder">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" class="my-0 py-0">
                        <v-text-field 
                          prepend-inner-icon="mdi-menu" 
                          outlined dense 
                          v-model="modulename" 
                          label="Modul/Nama menu">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" class="my-0 py-0">
                        <v-select 
                          dense outlined 
                          :items="moduleparent"  item-text="name_module" item-value="seq_module"  v-model="parentmodule" 
                          label="Module Parent">
                        </v-select>
                      </v-col>
                      
                      <v-col cols="12" sm="12" md="12" class="my-0 py-0">
                        <v-text-field 
                          prepend-inner-icon="mdi-menu" 
                          outlined dense 
                          v-model="modulevar" 
                          label="Modul Variable">
                        </v-text-field>
                      </v-col>
                      
                      <v-col cols="12" sm="12" md="12" class="my-0 py-0">
                        <v-text-field 
                          prepend-inner-icon="mdi-menu" 
                          outlined dense 
                          v-model="deskripsi" 
                          label="Deskripsi Modul">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" class="my-0 py-0">
                        <v-text-field 
                          prepend-inner-icon="mdi-menu" 
                          outlined dense 
                          v-model="colorclass" 
                          label="Color Class">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" class="my-0 py-0">
                        <v-select 
                          dense 
                          outlined 
                          :items="modulestatuslist"
                          item-text="namestatus" 
                          item-value="valuestatus" 
                          v-model="modulestatus" 
                          label="Status Menu"
                          hint="Enable or Disabled" persistent-hint
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" class="my-2">
                        <v-btn-toggle dense v-model="modul_config" multiple>
                          <v-btn ref="buttonView" >View</v-btn>
                          <v-btn ref="buttonInsert" >Insert</v-btn>
                          <v-btn ref="buttonUpdate" >Update</v-btn>
                          <v-btn ref="buttonDelete" >Delete</v-btn>
                        </v-btn-toggle>
                        <div>Access Configuration</div>
                      </v-col>

                      <v-col cols="12" sm="12" md="12" class="my-0 py-0">
                        <v-text-field 
                          prepend-inner-icon="mdi-sort" 
                          outlined dense 
                          v-model="sort" 
                          label="Sort">
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12" class="my-0 py-0">
                        <v-text-field 
                          prepend-inner-icon="mdi-play" 
                          outlined dense 
                          v-model="iconclass" 
                          label="Icon class">
                        </v-text-field>
                        <v-btn text @click="showIcon" class="v-btn--link">
                          Show Icon
                        </v-btn>
                      </v-col>
                      <v-col v-show=showiconclass cols="12" sm="12" md="12" class="my-0 py-0">
                        <!-- <v-btn-toggle class="my-4" mandatory v-model="modul_icon" > -->
                            <v-btn @click="selectOption('mdi-home')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-home</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-chart-line')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-chart-line</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-chart-bar')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-chart-bar</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-google-analytics')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-google-analytics</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-cloud')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-cloud</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-camera-metering-center')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-camera-metering-center</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-camera-metering-matrix')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-camera-metering-matrix</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-server')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-server</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-server')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-format-list-bulleted</v-icon> </v-btn>
                            
                            <v-btn @click="selectOption('mdi-cog-outline')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-cog-outline</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-cogs')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-cogs</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-twitter')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-twitter</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-youtube')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-youtube</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-web')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-web</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-instagram')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-instagram</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-facebook')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-facebook</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-facebook-messenger')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-facebook-messenger</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-google')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-google</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-skype')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-skype</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-email')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-email</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-forum-outline')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-forum-outline</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-animation')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-animation</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-animation-outline')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-animation-outline</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-animation-play')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-animation-play</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-animation-play-outline')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-animation-play-outline</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-signal-variant')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-signal-variant</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-antenna')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-antenna</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-access-point')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-access-point</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-api')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-api</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-api-off')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-api-off</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-fire')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-fire</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-cube')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-cube</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-cube-off')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-cube-off</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-cube-outline')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-cube-outline</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-cube-off-outline')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-cube-off-outline</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-cube-scan')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-cube-scan</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-cube-send')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-cube-send</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-laptop')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-laptop</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-puzzle-outline')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-puzzle-outline</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-account')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-account</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-account-multiple')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-account-multiple</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-account-group')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-account-group</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-account-details-outline')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-account-details-outline</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-table')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-table</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-pin')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-pin</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-content-copy')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-content-copy</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-keyboard-variant')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-keyboard-variant</v-icon> </v-btn>
                            <v-btn @click="selectOption('mdi-arrow-decision')" class="my-1 mx-1" style="min-width: 44px;"> <v-icon>mdi-arrow-decision</v-icon> </v-btn>
                          <!-- </v-btn-toggle> -->
                      </v-col>




                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>

              <v-divider></v-divider>
              <v-card-actions class="py-3">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense :loading="btnload" @click="save">
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogDelete" width="330px"> 
            <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
              <v-avatar class="color-avatar3 my-4" size="62">
                <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
              </v-avatar>
              <div class="text-center text-h6 align-center justify-center font-weight-medium">
                Confirm Deletion
              </div>
              <v-card-text class="align-center justify-center mt-2">
                Are you sure you want to permanently delete this item?
              </v-card-text>
              <v-divider class="mt-4" style=""></v-divider>
              <v-card-actions class="align-center justify-center">
                <v-btn rounded class="my-3 btn-ok" width="90px" dark @click="deleteItemConfirm">
                  OK
                </v-btn>
                <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeDelete">
                  Cancel
                </v-btn>
              </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <v-data-table  
      :items="menumanagement"
      :search="search"
      :items-per-page="100"
      class="table-user ml-6 mr-6 mt-4 rounded-lg"
      :loading="tableLoading"
      loading-text="Loading data..."
      hide-default-footer
      >
      <template v-slot:header >
        <thead >
          <tr>
            <th :colspan="4"> <b>NODULE NAME</b></th>
            <th> <b>UI Path/Folder Name</b></th>
            <th> <b>Module Var</b> </th>
            <th> <b>Parent Name</b> </th>
            <!-- <th> <b>Description</b> </th> -->
            <th> <b>Status</b> </th>
            <th> <b>Config</b> </th>
            <!-- <th> <b>Icon</b> </th> -->
            <th> <b>Icon</b> </th>
            <th> <b>Action</b> </th>
          </tr>
        </thead>
      </template>

        <template v-slot:item="{ item }">
          <tr >
            <td :colspan="4"><b>{{ item.MODULE_NAME }}</b></td>
            <td>{{ item.MODULE_URL }}</td>
            <td>{{ item.MODULE_VAR }}</td>
            <td>{{ item.MODULE_PARENT }}</td>
            <!-- <td>{{ item.MODULE_DESCRIPTION }}</td> -->
            <td>
              <template >
                <v-chip :color="getColor(item.MODULE_STATUS)"  text-color="white" label small pill>
                  {{ item.MODULE_STATUS }}
                </v-chip>
              </template>
            </td>
            <td>{{ item.MODULE_CONFIG }}</td>
            <!-- <td>{{ item.MODULE_ICON }}</td> -->
            <td>
              <template >
                <v-icon >{{ item.MODULE_ICON }}</v-icon>
              </template>
            </td>
            <td>
                <template  >
                  <v-icon class="mr-2" small  v-show=updateact  @click="editItem(item.MODULE_ID)">
                    mdi-pencil
                  </v-icon>
                  <v-icon small v-show=deleteact @click="deleteItem(item.MODULE_ID)">
                    mdi-delete
                  </v-icon>
                </template>
            </td>
          </tr>
          <template v-if="item.MODULE_CHILD && item.MODULE_CHILD.length > 0">
              <template  v-for="(child) in item.MODULE_CHILD" >
                <tr :key="'child-' + child.MODULE_ID">
                  <td></td>
                  <td :colspan="3"><b>{{ child.MODULE_NAME }}</b></td>
                  <td>{{ child.MODULE_URL }}</td>
                  <td>{{ child.MODULE_VAR }}</td>
                  <td>{{ child.MODULE_PARENT }}</td>
                  <!-- <td>{{ child.MODULE_DESCRIPTION }}</td> -->
                  <td>
                    <template >
                      <v-chip :color="getColor(child.MODULE_STATUS)"  text-color="white" label small pill>
                        {{ child.MODULE_STATUS }}
                      </v-chip>
                    </template>
                  </td>
                  <td>{{ child.MODULE_CONFIG }}</td>
                  <!-- <td>{{ child.MODULE_ICON }}</td> -->
                  <td>
                    <template >
                      <v-icon >{{ child.MODULE_ICON }}</v-icon>
                    </template>
                  </td>
                  <td>
                      <template  >
                        <v-icon class="mr-2" small  v-show=updateact  @click="editItem(child.MODULE_ID)">
                          mdi-pencil
                        </v-icon>
                        <v-icon small v-show=deleteact @click="deleteItem(child.MODULE_ID)">
                          mdi-delete
                        </v-icon>
                      </template>
                  </td>
                </tr>
                <template v-if="child.MODULE_CHILD && child.MODULE_CHILD.length != 0">
                
                  <template v-for="(sub_child) in child.MODULE_CHILD" >
                    <tr :key="'sub_child-' + sub_child.MODULE_ID">
                        <td></td>
                        <td></td>
                        <td :colspan="2"><b>{{ sub_child.MODULE_NAME }}</b></td>
                        <td>{{ sub_child.MODULE_URL }}</td>
                        <td>{{ sub_child.MODULE_VAR }}</td>
                        <td>{{ sub_child.MODULE_PARENT }}</td>
                        <!-- <td>{{ sub_child.MODULE_DESCRIPTION }}</td> -->
                        <td>
                          <template >
                            <v-chip :color="getColor(sub_child.MODULE_STATUS)"  text-color="white" label small pill>
                              {{ sub_child.MODULE_STATUS }}
                            </v-chip>
                          </template>
                        </td>
                        <td>{{ sub_child.MODULE_CONFIG }}</td>
                        <!-- <td>{{ sub_child.MODULE_ICON }}</td> -->
                        <td>
                            <template >
                              <v-icon >{{ sub_child.MODULE_ICON }}</v-icon>
                            </template>
                        </td>
                        <td>
                            <template  >
                              <v-icon class="mr-2" small  v-show=updateact  @click="editItem(sub_child.MODULE_ID)">
                                mdi-pencil
                              </v-icon>
                              <v-icon small v-show=deleteact @click="deleteItem(sub_child.MODULE_ID)">
                                mdi-delete
                              </v-icon>
                            </template>
                        </td>
                      </tr>
                    <template v-if="sub_child.MODULE_CHILD && sub_child.MODULE_CHILD.length != 0">
                      
                        <template v-for="(sub_sub_child) in sub_child.MODULE_CHILD" >
                          <tr :key="'sub_sub_child-' + sub_sub_child.MODULE_ID">
                            
                            <td></td>
                            <td></td>
                            <td></td>
                            <td ><b>{{ sub_sub_child.MODULE_NAME }}</b></td>
                            <td>{{ sub_sub_child.MODULE_URL }}</td>
                            <td>{{ sub_sub_child.MODULE_VAR }}</td>
                            <td>{{ sub_sub_child.MODULE_PARENT }}</td>
                            <!-- <td>{{ sub_sub_child.MODULE_DESCRIPTION }}</td> -->
                            <td>
                              <template >
                                <v-chip :color="getColor(sub_sub_child.MODULE_STATUS)"  text-color="white" label small pill>
                                  {{ sub_sub_child.MODULE_STATUS }}
                                </v-chip>
                              </template>
                            </td>
                            <td>{{ sub_sub_child.MODULE_CONFIG }}</td>
                            <!-- <td>{{ sub_sub_child.MODULE_ICON }}</td> -->
                            <td>
                              <template >
                                <v-icon >{{ sub_sub_child.MODULE_ICON }}</v-icon>
                              </template>
                            </td>
                            <td>
                                <template  >
                                  <v-icon class="mr-2" small  v-show=updateact  @click="editItem(sub_sub_child.MODULE_ID)">
                                    mdi-pencil
                                  </v-icon>
                                  <v-icon small v-show=deleteact @click="deleteItem(sub_sub_child.MODULE_ID)">
                                    mdi-delete
                                  </v-icon>
                                </template>
                            </td>
                          </tr>

                        </template>
                    </template>
                  </template>
                </template>
              </template>
          </template>
        </template>
    </v-data-table>
    <Notification  ref="alert"></Notification>
  </div>
</template>

<script>
import axios from "axios";
import { decryptionData } from '@/components/utils/utils.js';
import Notification from  '@/components/Notification';
import { mapGetters } from 'vuex';
  export default {
    components: {
      Notification: Notification
    },
    data: () => ({
      btnload:false,
      alertSuccess:'',
      alertFailed:'',
      alert_err_attention: "",

      deleteact: false,
      insertact: false,
      updateact: false,
      viewact: false,
      showiconclass: false,
      


      moduleparent: [{
        name_module :'',
        seq_module :''
      }
      ],
      dialog: false,
      dialogDelete: false,
      modulestatus: 1,
      modulestatuslist: [//choice select
        {valuestatus: 1, namestatus: "Enabled" },
        {valuestatus: 0, namestatus: "Disabled" }
      ],
      // variable 
      seq_id:'',
      modules: '',
      namefolder:'',
      modulename:'',
      modulevar:'',
      
      parentmodule:'',
      deskripsi:'',
      colorclass:'',
      iconclass:'',
      toggle_exclusive: [],
      modul_config: '',
      sort:'',
      // end variable 
      modules_val: [
          {namemodule: 'module', valuemodule: "module" },
        ],
      search:'',
      headers: [
        { text: 'Module Name', value: 'MODULE_NAME' },
        { text: 'UI Path/Folder Name', value: 'MODULE_URL' },
        { text: 'Parent Name', value: 'MODULE_PARENT' },
        { text: 'Description', value: 'MODULE_DESCRIPTION' },
        { text: 'Status', value: 'MODULE_STATUS' },
        { text: 'Config', value: 'MODULE_CONFIG' },
        { text: 'Icon', value: 'MODULE_ICON' },
        { text: 'Image', value: 'icon', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      menumanagement: [],
      editedIndex: -1,
      editedItem: {
      },
      defaultItem: {
      },
    }),
    computed: {
      page() {
        return this.$store.state.breadcrumbs
      },
      ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
      formTitle () {
        return this.editedIndex === -1 ? 'Add Menu Management' : 'Edit Menu Management'
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    created () {
      this.initialize()
    },
    methods: {
      
    getColor(status) {
      return status === 'Disabled' ? 'red' : 'green';
    },
    showIcon() {
      // this.selectedOption = value;
      if(this.showiconclass  == false){
        this.showiconclass  = true
      }else{
        this.showiconclass  = false

      }
       
    },
    selectOption(value) {
      this.iconclass  = value;
      this.showiconclass  = false

    },

    buildModuleOptions(modules, level = 0) {
      let result = [];

      modules.forEach(m => {
        result.push({
          name_module: `${'— '.repeat(level)}${m.MODULE_NAME}`,
          seq_module: m.MODULE_ID
        });

        if (m.MODULE_CHILD && m.MODULE_CHILD.length > 0) {
          result = result.concat(this.buildModuleOptions(m.MODULE_CHILD, level + 1));
        }
      });

      return result;
    },

      initialize () {
        this.tableLoading = true;
        this.menumanagement = [];
        axios.get("menu-management",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            let res = decryptionData(response.data.token);
            console.log(res);
            this.menumanagement = res.data

            // console.log( response.data.data)
            let result = '';
            let arr_data = [];
            result = {
              name_module : 'Top Menu',
              seq_module  : 0
            };
            // arr_data.push(result);

            // if(this.menumanagement.length > 0){
            //   for (let i = 0; i <  this.menumanagement.length; i++) {  
            //       result = {
            //         name_module : this.menumanagement[i].MODULE_NAME,
            //         seq_module  : this.menumanagement[i].MODULE_ID
            //       };
            //       arr_data.push(result);
            //   }
            //   this.moduleparent= arr_darr_dataata;
            // }

              if(this.menumanagement.length > 0){
                arr_data = arr_data.concat(
                  this.buildModuleOptions(this.menumanagement)
                );
              }

              this.moduleparent = arr_data;
            // end loading 
            setTimeout(() =>{
              this.loading = false
            },1000)
            
            this.tableLoading = false;
            if(localStorage.getItem('authactdeletedt') == 1){ this.deleteact = true }
            if(localStorage.getItem('authactinsert') == 1){ this.insertact = true }
            if(localStorage.getItem('authactupdate') == 1){ this.updateact = true }
            if(localStorage.getItem('authactview') == 1){ this.viewact = true }
          })
          .catch((e) => {
              switch (e.response.status) {
                 
                case 404:
                      this.$refs.alert.error_login(404);
                    break;
                case 403:
                      this.$refs.alert.error_login(403);
                    break;
                default:
                    console.log('some other error');  // end up here all the time
                    break;
              }
          this.errors=e.response.data.msg;
        });
      },
      
      editItem (item) {
        if(this.$refs.buttonView != undefined){
          if(this.$refs.buttonView.isActive == true){
            this.$refs.buttonView.$el.click();
          }
        }
        
        if(this.$refs.buttonInsert != undefined){
          if(this.$refs.buttonInsert.isActive == true){
            this.$refs.buttonInsert.$el.click();
          }
        }
        
        if(this.$refs.buttonUpdate != undefined){
          if(this.$refs.buttonUpdate.isActive == true){
            this.$refs.buttonUpdate.$el.click();
          }
        }
        
        if(this.$refs.buttonDelete != undefined){
          if(this.$refs.buttonDelete.isActive == true){
            this.$refs.buttonDelete.$el.click();
          }
        }


        this.editedIndex = 1
        this.inputItem = Object.assign({}, item)
        this.dialog = true
        axios({
          method: "put",
          url: "/menu-management-id",
          data: {
            id: item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            const dat = decryptionData(response.data.token);
            this.seq_id = dat.MODULE_ID;
            this.modules = dat.MODULE_TYPE;
            this.namefolder = dat.MODULE_URL;
            this.modulename = dat.MODULE_NAME;
            this.modulevar = dat.MODULE_VAR;
            
            this.parentmodule = dat.MODULE_PARENT;
            this.deskripsi = dat.MODULE_DESCRIPTION;
            this.colorclass = dat.COLOR_CLASS;
            this.iconclass = dat.MODULE_ICON;
            this.toggle_exclusive = dat.MODULE_CONFIG;
            this.modul_config = dat.MODULE_CONFIG;
            let config_btn = this.modul_config.split(',');
            console.log(config_btn);
            config_btn.forEach((val) => {
              if(val == 'VIEW'){
                this.$refs.buttonView.$el.click();
              }
              if(val == 'UPDATE'){
                this.$refs.buttonUpdate.$el.click();
              }
              if(val == 'INSERT'){
                this.$refs.buttonInsert.$el.click();
              }
              if(val == 'DELETE'){
                this.$refs.buttonDelete.$el.click();
              }
            });

            this.sort = dat.SORT_INDEX;
            this.modulestatus = dat.MODULE_STATUS;
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          // handle error
          this.loading = false

          console.log(error);
        })
      },
      deleteItem (item) {
        this.seq_id = item;
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        axios({
          method: "delete",
          url: "/menu-management/delete",
          data: {
            seq_id:  this.seq_id
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.closeDelete()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.closeDelete()
              } 
              this.initialize();
        })
        .catch(function (error) {
              this.alertFailed = true;
              this.alert_err_attention =  'Delete Failed '+error;
              this.closeDelete()
          // handle error
        })
        this.closeDelete()
      },
      close () {
        this.showiconclass  = false
        if(this.$refs.buttonView.isActive === true){
          this.$refs.buttonView.$el.click();
          this.$refs.buttonView.isActive = false;
        }
        if(this.$refs.buttonInsert.isActive === true){
          this.$refs.buttonInsert.$el.click();
          this.$refs.buttonInsert.isActive = false;
        }
        if(this.$refs.buttonUpdate.isActive === true){
          this.$refs.buttonUpdate.$el.click();
          this.$refs.buttonUpdate.isActive = false;
        }
        if(this.$refs.buttonDelete.isActive === true){
          this.$refs.buttonDelete.$el.click();
          this.$refs.buttonDelete.isActive = false;
        }
        this.$refs.form.reset()
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      save () {
        console.log(this.modul_config)
        var name_config = '' ;
        if(this.modul_config.length > 0){
          for (let i = 0; i <  this.modul_config.length; i++) {  
            if(i == 0){
              if(this.modul_config[i] == 0){
                name_config += 'VIEW';
              }else if(this.modul_config[i] == 1){

                name_config += 'INSERT';
              }else if(this.modul_config[i] == 2){
                name_config += 'UPDATE';
              }else if(this.modul_config[i] == 3){

                name_config += 'DELETE';
              }
            }else{
              if(this.modul_config[i] == 0){
                name_config += ',VIEW';
              }else if(this.modul_config[i] == 1){

                name_config += ',INSERT';
              }else if(this.modul_config[i] == 2){
                name_config += ',UPDATE';
              }else if(this.modul_config[i] == 3){

                name_config += ',DELETE';
              }
            }
          }
          console.log(name_config);
        }
        const isValid = this.$refs.form.validate();
        if (this.editedIndex > -1) {//update
          if (isValid) {
            
            this.btnload = true
            Object.assign(this.menumanagement[this.editedIndex], this.editedItem)
              axios.put("/menu-management/update", 
                {
                  module_id:this.seq_id,
                  module_url:this.namefolder,
                  module_name:this.modulename,
                  module_var:this.modulevar,
                  module_parent:this.parentmodule,
                  module_description:this.deskripsi,
                  module_config:name_config,
                  module_icon:this.iconclass,
                  sort_index:this.sort,
                  module_type:this.modules,
                  color_class:this.colorclass,
                  module_status:this.modulestatus,
                  module_content:'',
                  doc_id:0,
                },
                
                {headers:{'auth-token':localStorage.getItem('token_app')}},
                {dataType: 'json'}
                )
              .then((response) => {
                
                  this.initialize()
                  this.$router.push('/menumanagement');
                  var status = response.data.status
                  var messages = response.data.msg
                  if(status == 200){
                    this.alertSuccess = true;
                    this.alert_err_attention =  messages;
                    this.btnload = false
                    this.close()
                  }else{
                      this.alertFailed = true;
                      this.alert_err_attention =  messages;
                      this.btnload = false
                      this.close()
                  } 
                })
              .catch((e) => {
                    switch (e.response.status) {
                            case 404:
                                  this.$refs.alert.error_login(404);
                                break;
                            case 403:
                                  this.$refs.alert.error_login(403);
                                break;
                            case 400:
                                  this.alertFailed = true;
                                  this.alert_err_attention =  e.response.data.msg;
                                  this.btnload = false
                                break;
                            default:
                                console.log('some other error');  // end up here all the time
                                break;
                        }
                this.errors=e.response.data.msg;
              });
          }
        } else {//insert
          if (isValid) {
              this.btnload = true
              axios.post("/menu-management/insert", 
                {
                  module_url:this.namefolder,
                  module_name:this.modulename,
                  module_var:this.modulevar,
                  module_parent:this.parentmodule,
                  module_description:this.deskripsi,
                  module_config:name_config,
                  module_icon:this.iconclass,
                  sort_index:this.sort,
                  module_type:this.modules,
                  color_class:this.colorclass,
                  module_status:this.modulestatus,
                  module_content:'',                  
                  doc_id:0,

                },
                { headers:{'auth-token':localStorage.getItem('token_app')}},
                {dataType: 'json'}
                )
              .then((response) => {
                  this.$router.push('/menumanagement');
                  var status = response.data.status
                  var messages = response.data.msg
                  if(status == 200){
                    this.alertSuccess = true;
                    this.alert_err_attention =  messages;
                    this.btnload = false
                    this.close()
                  }else{
                      this.alertFailed = true;
                      this.alert_err_attention =  messages;
                      this.btnload = false
                      this.close()
                  } 
                })
              .catch((e) => {
                    switch (e.response.status) {
                        case 404:
                              this.$refs.alert.error_login(404);
                            break;
                        case 403:
                              this.$refs.alert.error_login(403);
                            break;
                        case 400:
                              this.alertFailed = true;
                              this.alert_err_attention =  e.response.data.msg;
                              this.btnload = false
                            break;
                        default:
                            console.log('some other error');  // end up here all the time
                            break;
                        }
                this.errors=e.response.data.msg;
              });
              this.initialize();
          }
        } 
        this.close()
      },
    },
  }
</script>

<style scoped>
.btn-ok{
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.v-avatar.color-avatar3
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
</style>
